export class AircraftUtilizationPutModel {
  public id?: number;
  public OwnerCode?: string;
  public AcRegId?: number;
  public FlightHour?: number;
  public FlightMinute?: number;
  public FlightCycle?: number;
  public PeriodYear?: number;
  public PeriodMonth?: number;
  public Status?: number;
  public ManufacturedDate?: Date;
  public UpdatedBy?: string;
  public UpdatedDate?: Date;
}

export class AircraftUtilizationBulkApproveModel {
  public OwnerCode?: string;
  public PeriodYear?: number;
  public PeriodMonth?: number;
  public Status?: number;
}

export interface AircraftUtilizationTempCreateDto {
  id: number;
  acReg: string;
  periodYear: number;
  periodMonth: number;
  flightHour: number;
  flightMinute: number;
  flightCycle: number;
  isSuccess: boolean;
  successMessage: string;
  description: string;
  isUpdate: boolean;
  existingId?: number;
}
